module.exports = __webpack_public_path__ + "static/media/kristea.01d59b20.png";